import BaseModifierBehavior from './BaseModifierBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { MathHelper } from '../../../Utility/MathHelper';
import { CardTask } from '../CardTasks';
import CardStateModifierHelper from '../CardStateModifierHelper';
import { ICardsState, ICardStateData } from '../ICardState';
import { ICardModifierData } from '../../../Prototype/Level/Card/ICardModifierData';
import { IGameState } from 'State/Game/IGameState';

export default class FogModifierBehavior extends BaseModifierBehavior {
    public updateCardFold(state: IGameState, sourceCardID: string): IGameState {
        // Do not play this card on the first turn (the initial card fold at the start of the level).
        if (state.levelState.cardsState.turns === 0) return state;
        // Play this modifier when a card is folded.
        return CardStateModifierHelper.playModifier(state, this.modifier, this.cardID);
    }

    public onOwnCardPlayed(state: IGameState): IGameState {
        return this.queueEndTask(state);
    }

    public onOwnCardDiscarded(state: IGameState): IGameState {
        return this.queueEndTask(state);
    }

    private queueEndTask(state: IGameState): IGameState {
        return CardStateHelper.updateGameState(
            state,
            CardStateHelper.setStateTaskData(state.levelState.cardsState, {
                task: CardTask.FOG_END,
                cards: [this.cardID],
            })
        );
    }

    public onCardFolded(state: IGameState, sourceCardID: string): IGameState {
        let cardsState = getCardsState(state);
        if (!this.validateUpdate(cardsState)) return state;

        // Do not play this card on the first turn (the initial card fold at the start of the level).
        if (cardsState.turns === 0) return state;

        // Play this modifier when a card is folded.
        return CardStateModifierHelper.playModifier(state, this.modifier, this.cardID);
    }

    public isBlocking(state: ICardsState): boolean {
        return MathHelper.pingPong(this.modifier.properties.plays, 2) === 0;
    }

    public onCardMatched(state: IGameState, matchedCardID: string): IGameState {
        if (!this.validateUpdate(state.levelState.cardsState)) return state;

        if (matchedCardID === this.cardID) return state;

        // Play this modifier when a card is played.
        return CardStateModifierHelper.playModifier(state, this.modifier, this.cardID);
    }

    public onUndoUsed(state: IGameState, prevCardState: ICardStateData, prevModifier: ICardModifierData): IGameState {
        if (!this.validateUpdate(state.levelState.cardsState)) return state;

        const cardsState = this.updateModifier(state.levelState.cardsState, this.cardID, {
            properties: {
                ...this.modifier.properties,
                plays: prevModifier.properties.plays,
            },
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }
}
